import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-md mx-auto">
            多种分类任你选择，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-100 rounded-lg hover:bg-primary-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}